import { APP_BASE_HREF, Location } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { DataService } from '@app/_core/services/data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { AddFindMemberComponent } from '@app/pages/queue/common/case-detail/cases/add-find-member/add-find-member.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map, Subject } from 'rxjs';
import { SelectAgentComponent } from '../select-agent/select-agent.component';
import { TranscriptService } from '@app/_core/services/transcript-service.service';

@Component({
  selector: 'app-voicemail-details',
  templateUrl: './voicemail-details.component.html',
  styleUrls: ['./voicemail-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VoicemailDetailsComponent implements OnInit {
  modalRef?: BsModalRef;
  playerDetails: any;
  interactions: any = [];
  showAgentPicker: boolean = false;
  //interactionDataToDisplay:any=[];
  voicemailID = null;
  agentID = null;
  /*		audioHolder:any;
            gridHolder:any;
      interactionsGrid:any;
      agentPicker:any;
      agentDisplay:any;*/

  audioSource: string = '';
  data: any;
  recordingDetails: any;
  isRecordLoaded: boolean = false;

  cols: any = [
    { label: 'ID', hide: false },
    { label: 'Queue', showFilter: false },
    { label: 'Type', showFilter: false },
    { label: 'Date', type: 'date', showFilter: false },
  ];

  voiceMailDetail: any;
  clientUserDetail: any;

  title: string = '';
  audioRecordingFile: any;
  showSelectAgent: boolean = false;
  position: any = 'center';
  searchedUserData: any;
  transcriptSpeaker: string = '';
 
  transcriptText: string = '';
  // services/Data/GetClientUser

  constructor(
    private utils: Utils,
    private route: ActivatedRoute,
    private transcriptService: TranscriptService,
    private router: Router,
    private modalService: BsModalService,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private dataService: DataService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private location: Location
  ) {
    this.route.params.subscribe((params: any) => {
     // console.log(params);
      //  alert(params.id)
      if (!this.voicemailID) {
        this.GetVoicemailByID(params.id);
      }
      // this.GetAgentQueues(params.id);
      // this.GetAgentSkills(params.id);
      //this.loadSkillAgents(params.id)
    });
  }

  ngOnInit(): void {}

  GetVoicemailByID(id: number) {
    this.managerService
      .GetVoicemailByID(id)
      .pipe(
        map((data: any) => {
          console.log(data, 'voiceMailDetailData');
          this.audioRecordingFile = data.Response.Data.URL;
          this.getRecordingData(this.audioRecordingFile);

          const isValid = ResponseHandler.processResponse(data, 'GetVoicemailByID');
          if (isValid) {
            //       {"Data":{"ID":107,"InteractionID":19875,"Queue":"Janendra Inbound 1","UserID":5188,"User":"Ranjith Kumar","Company":"CTS","UserPhoneNumber":"(253) 655-3963","AgentID":5178,"Name":"Akshita Gupta3","Agent":"Akshita Gupta3","InboundPhoneNumber":"(720) 605-4019","InboundSkills":[],"RequestType":null,"FileID":231,"URL":"/PrivateFiles/QA1/files/231/Voicemail_CAe27645658f8c4256fc841c1a9976d78b.mp3","Duration":2,"Transcript":null,"Status":"New","Created":"\/Date(1675920097483)\/","Reviewed":null,"Responded":null,"Deleted":null,"LastUpdated":"\/Date(1675920097483)\/","Responses":[]},"Status":1,"Message":null}

            this.updateDisplayWithContent(data.Response.Data);
            this.getVoicemailTranscript(data.Response.Data.InteractionID);
            // this.voiceMailDetail = data.Data;
            // this.title = "Voicemail " + data.ID + " - " + ((data.User == null) ? ((data.Company == null) ? "<nobr>" + data.UserPhoneNumber + "</nobr>" : data.Company) : data.User) + " (Agent: " + data.Agent + ")";
            //this.voicemailID = data.ID;

            //  this.GetClientUser(this.voiceMailDetail.AgentID);

            //"skill", "agent", this.service(), "GetSkillAgents", true, true, !cls.QBRSecurity().validateGrant("ManageAssignments")
            //detail:skillDetail, agentlist:agentList,
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  updateDisplayWithContent(data: any) {
    this.showAgentPicker = data.Agent == null || data.Responded == null;
    //   agentDisplay.visible(data.Agent != null && data.Reviewed != null);
    if (data.Agent == null) {
      data.Agent = 'Unassigned';
    }
    data.Created = this.utils.formatDateTime(this.utils.convertServerDate(data.Created));
    data.Reviewed =
      data.Reviewed == null ? null : this.utils.formatDateTime(this.utils.convertServerDate(data.Reviewed));
    data.Responded =
      data.Responded == null ? null : this.utils.formatDateTime(this.utils.convertServerDate(data.Responded));
    data.Deleted = data.Deleted == null ? null : this.utils.formatDateTime(this.utils.convertServerDate(data.Deleted));
    data.InboundSkills =
      data.InboundSkills != null && data.InboundSkills.length > 0 ? data.InboundSkills.join(', ') : null;
    //  cls.superclass().updateDisplayWithContent.call(this, data);
    // this.title =
    //   'Voicemail ' +
    //   data.ID +
    //   ' - ' +
    //   (data.User == null ? (data.Company == null ? data.UserPhoneNumber : data.Company) : data.User) +
    //   ' (Agent: ' +
    //   data.Agent +
    //   ')';
    this.voicemailID = data.ID;
    this.agentID = data.AgentID;
    this.voiceMailDetail = data;
    this.updateTitle();

    //this.playerDetails.src= "http://localhost:4200/assets/audio/Onvida_QA1_2023-02-08_19874_NusrathSyed_Video.mp4";
    //this.playerDetails.src= "http://localhost:4200/assets/audio/Onvida_QA1_2023-02-09_107_RanjithKumar_Voicemail1.mp3";

    //this.playerDetails.type='video';

    this.playerDetails = {
      title: this.title + ' - Audio Recording',
      suffix: 'Voicemail',
      type: 'audio',
      // src: data.URL,
      src: 'http://localhost:4200/assets/audio/Onvida_QA1_2023-02-09_107_RanjithKumar_Voicemail1.mp3',
      downloadFileName: this.getDownloadFileName(data, data.URL, 'Voicemail', undefined),
      enableFileDownload: true,
      autoRefreshPopup: true,
      playerAttrs: {
        width: 550,
      },
    };

    /* var audioPlayer = new im.MediaPlayer({
           title: this.setTitle() + ' - Audio Recording',
           suffix: 'Voicemail',
           type: 'audio',
           src: data.URL,
       downloadFileName: getDownloadFileName(data, data.URL, 'Voicemail'),
           enableFileDownload: true,
           autoRefreshPopup: true,
       playerAttrs: {
         width: 550
       }
       });
       audioPlayer.height('100%');
     audioHolder.addSubView(audioPlayer);
     audioPlayer.initialize();*/

    this.interactions.push({
      ID: data.InteractionID,
      Queue: data.Queue,
      Type: 'Voicemail',
      Date: data.Created,
    });

    for (let i = 0; i < data.Responses.length; i++) {
      this.interactions.push({
        ID: data.Responses[i].InteractionID,
        Queue: data.Responses[i].Queue,
        Type: data.Responses[i].InteractionType,
        Date: data.Responses[i].Created,
      });
    }
    this.sortByColumn('Date');
    //this.interactionDataToDisplay = this.interactions;
    /* interactionsGrid.data(interactions, false, function(){
       interactionsGrid.sortColumn('Date', true);
     });*/
  }

  selectAgent() {
    // this.showSelectAgent = true;
   
      // this.FindMemberValue = null;
      // let findMemberData = this.appService.getLookUpMemberId();
      // findMemberData?.forEach(memberData => {
      //   if (memberData.caseId == this.selectedCaseId && memberData.fieldID == selectedField.fieldID) {
      //     this.FindMemberValue = memberData.findMemberId;
      //   }
      // });
      console.log(  this.agentID )
      let searchObject: any = {
        type: 'ID',
        value: this.agentID,
      };
      const initialState = {
        // Heading: 'Select Find Member',
        // Data: 'caseDetail',
        // reason: 'add-find-member',
        searchMemberObject: searchObject,
        // reason: event.target.id,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'select-agent-menu',
        initialState,
      };
      this.modalRef = this.modalService.show(SelectAgentComponent, config);
      
      this.modalRef.content.onClose = new Subject<boolean>();

    this.modalRef.content.onClose.subscribe(result => {
     console.log('results', result);
      this.searchedUserData = result;
      this.updateSelectedAgent(this.searchedUserData)
      // this.conf.Groups.forEach(group => {
      //   group?.Fields?.forEach(field => {
      //     if (field.fieldType == 'CaseUserPicker' && field.fieldID == selectedField.fieldID) {
      //       field.value = this.searchedUserData.FirstName + ' ' + this.searchedUserData.LastName;
      //       this.FindMemberValue = this.searchedUserData.UserID;

      //       let event = {
      //         target: {
      //           value: this.FindMemberValue,
      //         },
      //       };
      //       if (field.FindMemberFieldConfigRequired) this.getFindMemberFieldConfiguration(field, this.FindMemberValue);
      //       this.onFormDataChange(group, field, event, this.FindMemberValue);
      //       this.initializeFormData();

      //       let data = {
      //         caseId: this.selectedCaseId,
      //         findMemberId: this.FindMemberValue,
      //         fieldID: field.fieldID,
      //         fieldName: field.Name,
      //       };
      //       this.formData[field.Name] = field.value;
      //       this.appService.setLookUpMemberId(data);
      //     }
      //   });
      });
  }

  updateSelectedAgent(item: any) {
    console.log(item);
    this.agentID = item.UserID;
    this.voiceMailDetail.Agent = item.FullName;
    this.showSelectAgent = false;
    this.updateTitle();
  }

  deleteAssignedAgent() {
    const initialState = {
      title: 'Are you sure?',
      contentMsg: 'You are about to remove the associated agent, Do you wish to continue?',
      confirmBtnValue: 'Ok',
      cancelBtnValue: 'Cancel',
    };

    const config: ModalOptions = {
      class: 'confirm-dialog modal-wd-290',
      initialState,
    };

    this.modalRef = this.modalService.show(ConfirmDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      if (result.value == 'confirm') {
        this.agentID = null;
        this.voiceMailDetail.Agent = 'Unassigned';
        this.updateTitle();
      }
      this.modalRef.hide();
    });
  }

  updateTitle() {
    this.title =
      'Voicemail ' +
      this.voiceMailDetail.ID +
      ' - ' +
      (this.voiceMailDetail.User == null
        ? this.voiceMailDetail.Company == null
          ? this.voiceMailDetail.UserPhoneNumber
          : this.voiceMailDetail.Company
        : this.voiceMailDetail.User) +
      ' (Agent: ' +
      this.voiceMailDetail.Agent +
      ')';
  }

  /*GetClientUser(id: number) {
    this.dataService
      .GetClientUser(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetClientUser');
          if (isValid) {
            this.clientUserDetail = data.Response.Data;
            // this.title ="Agent " + this.voiceMailDetail.ID + " - " + this.voiceMailDetail.Name;
            // this.GetClientUser(this.voiceMailDetail.AgentID);

            //"skill", "agent", this.service(), "GetSkillAgents", true, true, !cls.QBRSecurity().validateGrant("ManageAssignments")
            //detail:skillDetail, agentlist:agentList,
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }*/

  getDownloadFileName(data: any, fileURL: any, recordingType: any, ext: any) {
    const timeStamp: any = this.utils.convertServerDate(data.Created);
    let timeStampMonth = timeStamp.getMonth() + 1;
    timeStampMonth = timeStampMonth < 10 ? '0' + timeStampMonth : timeStampMonth;
    const timeStampDay = timeStamp.getDate() < 10 ? '0' + timeStamp.getDate() : timeStamp.getDate();

    let fileName = 'Onvida_' + this.securityService.clientAbbr;
    fileName += '_' + timeStamp.getFullYear() + '-' + timeStampMonth + '-' + timeStampDay;
    fileName += '_' + data.ID;
    fileName += '_' + (data.User == null ? 'UnknownUser' : data.User.replace(' ', ''));
    fileName += '_' + recordingType;
    fileName += '.' + (typeof ext != 'undefined' || fileURL == null ? ext : this.utils.getFileExtension(fileURL));

    return fileName;
  }

  sortByColumn(colName: string) {
    this.interactions = this.utils.sortByField(colName, this.cols, this.interactions);
  }

  onRowSelect(event: any) {
    //console.log(event);

    this.router.navigateByUrl('Console/Auditing/Interactions/Details/' + event.data.ID);
    // this.router.navigate(['/Console/Auditing/Interactions/Details/' + event.data.ID])
    // this.router.navigateByUrl("Console/Auditing/Interactions/Details/"+'1447457')
  }

  saveChanges() {
    const data = {
      id: this.voicemailID,
      agentID: this.agentID ? this.agentID : -1,
      status: null,
    };
    this.managerService
      .EditVoicemail(data)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditVoicemail');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }

  goBack() {
    this.location.back();
  }

  getRecordingData(file) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
      const binaryData = 'data:audio/wav;base64,' + data.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: 'audio/mp3' });
      const blobUrl = URL.createObjectURL(blob);
      this.audioSource = blobUrl;
      this.recordingDetails = this.audioSource;
      this.isRecordLoaded = true;
    });
  }
  getVoicemailTranscript(interactionId: number) {
    this.transcriptService.
    GetPostCallAnalyticsByInteractionID(interactionId, 3)
      .subscribe(
        (res: any) => {
         
          const transcriptData = res?.Response?.Data;
 
          if (transcriptData?.Sentences?.length) {
 
            this.transcriptSpeaker =
              transcriptData.Sentences[0]?.SpeakerRole || 'Transcript';
 
              this.transcriptText =
              transcriptData.Sentences
                .map((x: any) => x.Transcript)
                .join('\n\n');
          }
        },
        err => {
          console.log('Transcript Error', err);
        }
      );
  }
}
